import useSWR from 'swr'

import { options, propertyApi } from '../../apis/suitebookClient'
import { filterAreas } from '../../utils'

type UseNearbyHotelsApiProps = {
  checkInDate: string
  checkOutDate: string
  roomCount: number
  numberOfAdults: number
  numberOfChildren: number
  numberOfInfants: number
  limit?: number
  areas?: string[]
  // false の間はフェッチしない（SWR キーを null にする）。満室確定時に
  // RoomIndex 側から先行ウォームアップする用途でも、同一キーなので
  // SoldOutRecommend 側の呼び出しとキャッシュを共有する。
  enabled?: boolean
}

export const useNearbyHotelsApi = ({
  checkInDate,
  checkOutDate,
  roomCount,
  numberOfAdults,
  numberOfChildren,
  numberOfInfants,
  limit = 10,
  areas,
  enabled = true,
}: UseNearbyHotelsApiProps) => {
  const key = JSON.stringify({
    nearby: true,
    checkInDate,
    checkOutDate,
    roomCount,
    numberOfAdults,
    numberOfChildren,
    numberOfInfants,
    limit,
    areas,
  })
  const {
    data: { results, count } = {},
    isLoading,
    error,
  } = useSWR(enabled ? `/hotels/rooms/nearby?${key}` : null, () =>
    propertyApi
      .getHotelRooms(
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        0, // offset
        limit,
        true, // isHotel
        undefined, // insideFvillage
        filterAreas(areas),
        'distance', // 近い順
        undefined, // showAll
        undefined, // equipments
        options
      )
      .then((res) => res.data)
  )

  return { data: results, count, isLoading, error }
}
